import script from "./StoreAdminLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminLogin.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminLogin.vue?vue&type=style&index=0&id=ded93598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded93598"]])

export default __exports__